import React from 'react'
import { getDecimalPlaces, formatDecimalInput } from '../../utils/constants'

export function DecimalInput({ value, onChange, units, className, placeholder, autoFocus }) {
  const decimalPlaces = getDecimalPlaces(units)

  if (!decimalPlaces) {
    return (
      <input
        type="text"
        inputMode="decimal"
        value={value}
        onChange={onChange}
        className={className}
        placeholder={placeholder}
        autoFocus={autoFocus}
      />
    )
  }

  const handleChange = (e) => {
    const digits = e.target.value.replace(/[^\d]/g, '')
    const formatted = formatDecimalInput(digits, decimalPlaces)
    onChange({ target: { value: formatted } })
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Backspace') {
      e.preventDefault()
      const digits = (value || '').replace(/[^\d]/g, '').slice(0, -1)
      const formatted = digits ? formatDecimalInput(digits, decimalPlaces) : ''
      onChange({ target: { value: formatted } })
    }
  }

  return (
    <input
      type="text"
      inputMode="numeric"
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      className={className}
      placeholder={placeholder}
      autoFocus={autoFocus}
    />
  )
}
